import { createContext } from 'react'

interface IProps {
    width: number | string | undefined
}
export const CarouselContext = createContext({
    width : 400
} )
